import { adminRequestsTyped } from "@/api/(requests)/adminTyped";

export type UpdateAdminProfileVariables = {
  email?: string;
  mobile?: string;
  name?: string;
  preferences?: Record<string, unknown>;
};

export async function updateAdminProfile(data: UpdateAdminProfileVariables): Promise<void> {
  return adminRequestsTyped.update_profile({ data });
}
